import EventEmitter from "events";
import _ from "lodash";

class Playable extends EventEmitter {
  constructor(audio) {
    super();
    this.audio = audio;
  }
  // eslint-disable-next-line class-methods-use-this
  makeWaveGetter() {
    return () => [];
  }
  play(param = {}) {
    return new Promise(resolve => {
      if (!this.audio) {
        resolve();
        return;
      }
      const offset = param.offset || 0;
      if (this.audio.currentTime !== offset) {
        this.audio.currentTime = offset;
      }

      const volume = _.isNumber(param.volume) ? param.volume : 1;
      this.setVolume(volume);

      this.audio.play();
      this.emit("play");
    });
  }
  resume() {
    return this.play({ offset: this.getCurrentTime() });
  }
  stop() {
    if (!this.audio) return;
    this.audio.pause();
    this.emit("stop");
  }
  getCurrentTime() {
    if (!this.audio) return 0;
    return this.audio.currentTime;
  }
  getProgress() {
    return [this.getCurrentTime(), this.audio ? this.audio.duration : 0];
  }
  setVolume(v) {
    if (!this.audio) return;
    this.audio.volume = _.clamp(v, 0, 1);
  }
}

export default class PolyfillAudioAPI extends EventEmitter {
  // eslint-disable-next-line class-methods-use-this
  loadSound(src, opts = {}) {
    return new Promise(resolve => {
      if (opts.skipMix) {
        setTimeout(() => {
          resolve(new Playable());
        });
        return;
      }
      const audio = new Audio(src);
      const playable = new Playable(audio);
      let hasLoaded = false;
      const onload = () => {
        if (hasLoaded) return;
        hasLoaded = true;
        resolve(playable);
      };
      audio.addEventListener("canplay", onload);
      audio.load();

      // 15秒経ったら強制で進めてしまう
      setTimeout(onload, 15 * 1000);
    });
  }
  // eslint-disable-next-line class-methods-use-this
  ping() {}
}
